<template>
  <div>
    <div v-if="invoiceList.length">
      <b-table
        @row-selected="rowSelected"
        select-mode="multi"
        ref="invoiceTable"
        selectable
        stacked="sm"
        hover
        :fields="fields"
        :items="invoiceList"
      >
        <template slot="HEAD_total">
          Total
          <i
            v-b-tooltip.hover
            title="Verdi per innløst opplevelse. Utsalgspris - provisjon(eks. mva)."
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="HEAD_verdibevis">
          Verdibevis
          <i
            v-b-tooltip.hover
            title="Verdibevisnummer som har blitt løst inn"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="HEAD_navn">
          Navn
          <i
            v-b-tooltip.hover
            title="Navn på opplevelsen som har blitt løst inn"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="HEAD_dato">
          Dato
          <i
            v-b-tooltip.hover
            title="Dato for når verdibeviset har blitt løst inn"
            class="fa fa-info-circle hoverable"
          ></i>
        </template>

        <template slot="total" slot-scope="data">
          {{ parseInt(data.value).toFixed(2) }} kr
        </template>

        <template slot="select" slot-scope="row">
          <b-form-checkbox v-model="row.rowSelected" @change="clickRows([row.index])">
          </b-form-checkbox>
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template slot="HEAD_select">
          <b-form-checkbox
            v-model="allSelected"
            @change="selectAll"
            :indeterminate="partlySelected"
          >
          </b-form-checkbox>
        </template>

        <template slot="dato" slot-scope="data">
          {{ formatDate(data.value) }}
        </template>
      </b-table>
      <b-button v-if="selected.length" @click="addToInvoice" variant="primary"
        >Legg til oppgjør</b-button
      >
    </div>
    <b-alert :show="invoiceList.length === 0" variant="dark" class="text-center">
      <strong>Listen er tom!</strong> Løs inn verdibevis for å motta oppgjør
    </b-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  format, //
  subDays,
  parseISO,
  isBefore,
} from 'date-fns';
import { nb } from 'date-fns/locale';

export default {
  data() {
    return {
      fields: [{ key: 'select', label: '' }, 'verdibevis', 'navn', 'total', 'dato'],
      allSelected: false,
      partlySelected: false,
    };
  },
  computed: {
    ...mapGetters({
      invoiceList: 'invoices/canBeInvoicedTable',
      selected: 'invoices/selected',
    }),
  },
  methods: {
    ...mapMutations({
      setSelected: 'invoices/set_selected',
    }),
    ...mapActions({
      addToInvoice: 'invoices/addToInvoice',
    }),
    addRowsToInvoice() {
      this.addToInvoice().then(res => {
        this.$bvToast.toast('De valgte verdibevisen er nå lagt til fakturering', {
          variant: 'success',
          title: `Lagt til fakturering`,
          autoHideDelay: 5000,
        });
      });
    },
    selectAll() {
      if (this.selected.length === this.invoiceList.length) {
        this.$refs.invoiceTable.clearSelected();
        this.allSelected = false;
      } else {
        this.$refs.invoiceTable.clearSelected();
        this.clickRows([...Array(this.invoiceList.length).keys()]);
        this.allSelected = true;
      }
    },
    clickRows(which) {
      const myTable = this.$refs.invoiceTable.$el;
      const tableBody = myTable.getElementsByTagName('tbody')[0];
      const tableRows = tableBody.getElementsByTagName('tr');
      which.forEach(idx => tableRows[idx].click());
    },
    rowSelected(items) {
      this.setSelected(items);

      if (items.length === this.invoiceList.length && items.length > 0) {
        this.allSelected = true;
        this.partlySelected = false;
      } else if (items.length > 0) {
        this.allSelected = false;
        this.partlySelected = true;
      } else {
        this.allSelected = false;
        this.partlySelected = false;
      }
    },
    formatInvoiceDate(date) {
      const invoiceDate = parseISO(date);
      if (isBefore(invoiceDate, new Date('2016-09-30 23:59:59'))) {
        return format(invoiceDate, 'yyyy-MM-dd', { locale: nb });
      }
      return format(subDays(invoiceDate, 1), 'MMMM yyyy', { locale: nb });
    },
  },
};
</script>

<style>
tr {
  outline: none;
}

.custom-control-label {
  cursor: pointer;
}
</style>
